<template>
  <div>
    <template v-if="isShowProductShortDesc">
      <div :class="['p-short-desc', descClass]" :style="[descStyles]">{{product.short_desc}}</div>
    </template>
    <template v-if="isShowProductDesc">
      <div :class="['p-desc', descClass]" :style="[descStyles]">{{product.desc}}</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "ProductDesc",
  props: ["product"],
  computed: {
    // desc
    isShowProductShortDesc: function() {
      return this.$store.state.front.settings.shortDescDisplay;
    },
    isShowProductDesc: function() {
      return this.$store.state.front.settings.descDisplay;
    },
    descStyles: function() {
      return {
        color: this.$store.state.front.settings.descColor,
        fontSize: this.$store.state.front.settings.descFontsize + "px"
      };
    },
    descClass: function() {
      return this.$store.state.front.settings.descClass;
    }
  }
};
</script>
